import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('http://localhost:5000/api/products')
      .then(res => res.json())
      .then(data => {
        if (data && data.products) {
          setProducts(data.products);
        } else {
          throw new Error("Invalid response format");
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching API, using fallback data:', err);
        // Fallback data for the live demo on GitHub Pages
        const fallbackData = [
          {
            _id: '1',
            name: 'Advanced Anti-Aging Serum',
            description: 'Reduces fine lines and improves skin elasticity.',
            price: 1599,
            originalPrice: 2499,
            discount: 36,
            image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60'
          },
          {
            _id: '2',
            name: 'Retinol Night Cream',
            description: 'Deep hydration and skin renewal formula.',
            price: 1299,
            originalPrice: 1999,
            discount: 35,
            image: 'https://images.unsplash.com/photo-1629198688000-71f23e745b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60'
          },
          {
            _id: '3',
            name: 'Vitamin C Glow Serum',
            description: 'Brightens skin tone and reduces dark spots.',
            price: 999,
            originalPrice: 1499,
            discount: 33,
            image: 'https://images.unsplash.com/photo-1599305090598-fe179d501227?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60'
          },
          {
            _id: '4',
            name: 'Hyaluronic Acid Gel',
            description: 'Intense moisture lock for plump skin.',
            price: 899,
            originalPrice: 1299,
            discount: 30,
            image: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60'
          }
        ];
        setProducts(fallbackData);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px', fontSize: '24px' }}>Loading...</div>;
  }

  return (
    <div style={{ background: '#fdf5f3', minHeight: '100vh', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', fontSize: '3rem', marginBottom: '40px' }}>
        ✨ Anti-Aging Products
      </h1>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '20px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {products.map(product => (
          <div key={product._id} style={{
            background: 'white',
            borderRadius: '15px',
            overflow: 'hidden',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <img
              src={product.image}
              alt={product.name}
              style={{ width: '100%', height: '300px', objectFit: 'cover' }}
            />

            <div style={{ padding: '20px' }}>
              <h3 style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
                {product.name}
              </h3>

              <p style={{ color: '#666', marginBottom: '15px' }}>
                {product.description}
              </p>

              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                  ₹{product.price}
                </span>
                <span style={{ color: '#999', textDecoration: 'line-through' }}>
                  ₹{product.originalPrice}
                </span>
                <span style={{ color: 'green', fontWeight: 'bold' }}>
                  {product.discount}% OFF
                </span>
              </div>

              <button style={{
                width: '100%',
                background: 'linear-gradient(135deg, #e91e63, #9c27b0)',
                color: 'white',
                border: 'none',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '1rem',
                cursor: 'pointer'
              }}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '60px', padding: '20px' }}>
        <h2>🎉 Project Complete!</h2>
        <p>✅ Backend Running | ✅ MongoDB Connected | ✅ 12 Products Loaded</p>
      </div>
    </div>
  );
}

export default App;
